export const CAMP_REGISTRATION_STATUS_LABELS: Record<string, string> = {
  pending: "ລໍຖ້າຕິດຕໍ່",
  contacted: "ຕິດຕໍ່ແລ້ວ",
  confirmed: "ຢືນຢັນແລ້ວ",
  rejected: "ປະຕິເສດ",
  duplicate: "ຊ້ຳ",
  converted: "ແປງເປັນນັກຮຽນແລ້ວ",
};

export const CAMP_REGISTRATION_STATUS_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  pending: "outline",
  contacted: "secondary",
  confirmed: "default",
  rejected: "destructive",
  duplicate: "outline",
  converted: "secondary",
};

export const CAMP_GENDER_LABELS: Record<string, string> = {
  male: "ຊາຍ",
  female: "ຍິງ",
  other: "ອື່ນໆ",
};

export function getCampSlotDotClass(availability?: string): string {
  switch (availability) {
    case "open":
      return "camp-slot-dot--open";
    case "low":
    case "critical":
      return "camp-slot-dot--low";
    case "full":
      return "camp-slot-dot--full";
    default:
      return "camp-slot-dot--open";
  }
}

export const CAMP_EVENT_STATUS_LABELS: Record<string, string> = {
  draft: "ຮ່າງ (ຍັງບໍ່ເປີດ)",
  open: "ເປີດຮັບສະໝັກ",
  closed: "ປິດຮັບສະໝັກ",
};

export const CAMP_EVENT_STATUS_VARIANTS: Record<
  string,
  "default" | "secondary" | "destructive" | "outline"
> = {
  draft: "outline",
  open: "default",
  closed: "secondary",
};

export const CAMP_EVENT_STATUS_HINTS: Record<string, string> = {
  draft: "ຟອມສາທານະຈະບໍ່ຮັບສະໝັກ — ໃຊ້ທົດສອບກ່ອນເປີດ",
  open: "ເວັບ Summer Camp ສາມາດສົ່ງໃບສະໝັກໄດ້",
  closed: "ເວັບຈະສະແດງຫນ້າປິດຮັບສະໝັກ",
};
